import { defineRouting } from 'next-intl/routing';

// Path-based locales for public and tenant pages. English is unprefixed (`/`)
// and other locales are prefixed (`/fr`, `/de`, `/es`). Adding a locale = one
// entry here + one `messages/<x>.json` + one Clerk localization mapping in the
// root layout.
export const routing = defineRouting({
  // Region-specific where a variant matters: pt-BR (Brazilian, not pt-PT) and
  // zh-CN (Simplified, not zh-TW). The code is the URL segment (`/pt-BR`) and the
  // Clerk bundle key, so it's chosen deliberately rather than the bare language.
  locales: ['en', 'fr', 'de', 'es', 'pt-BR', 'ja', 'zh-CN'],
  defaultLocale: 'en',
  // '/' = en (no prefix), '/fr' = fr, etc. Keeps the existing `/` URL working.
  localePrefix: 'as-needed',
  // Signed-in users are redirected to their saved locale in `proxy.ts`; we don't
  // auto-redirect anonymous visitors off `/` based on Accept-Language.
  localeDetection: false,
});
